import { SessionService } from './shared/session.service';

export function localeFactory(sessionService: SessionService): string {
    return sessionService.locale;
}
